import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AuthService from "../service/auth-service";
import i18n from "../plugins/locale/i18n";
import loadDictionary from "../plugins/locale/load-dictionary";

const authService = new AuthService();

await loadDictionary('global');

function Layout() {
    const navigate = useNavigate();
    const handleLogout = () => {
        authService.logout();

        navigate("/login");
    };
    
    useEffect(() => {
        if(!sessionStorage.getItem('auth-token')) {
            navigate("/login");
        }
    }, [navigate]);
    
    return (
        <>
        <header className="navbar navbar-expand-lg position-sticky border-bottom top-0 bg-white z-1 px-3">
            <nav className="container-fluid">
                <a href="/" className="navbar-brand fs-5 fw-bold">{i18n.t('global.appName')}</a>
                <button onClick={handleLogout} className="btn navbar-btn">{i18n.t('global.logout')}</button>
            </nav>
        </header>
        <Outlet />
        </>
    );
}

export default Layout;